const config = {
  googleAnalyticsTrackingId: "UA-90851529-1",
  mixpanelToken: '82c86744eeb53101638cc8cf48de63ec',
  apiUrl: "https://api.sunbit.com",
  apiUrlPci: 'https://api-icp.sunbit.com',

  features: {
  },
  fingerprintjs: {
    "token": "jRJ6Bdd3OtOMWqeOmSiG",
    "endpoint": "https://fp.sunbit.com"
  },
  sampling: {
    "endpoint": "https://api.sunbit.com/sampling/api/v1/sampling"
  },
  recaptchaKey: "6LeNt5EbAAAAAKjUCuGDZbSQqR7jPGDC1PoH1huY",
  launchDarklyClientId: '6499466b1a95581354454ed7',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/prod.js